/**
 * Workflow account-repair facts shared by the routine header, the trigger and the repair banner
 * (ACT2-1286 PR 2b, spec UI 14).
 */
import type { WorkflowAccountRepairView } from '@server/warehouse-repair-state';

/** Only an admin resumes a routine paused for repair (spec "Who can repair", Resume). */
export const RESUME_ADMIN_ONLY = 'Only workspace admins can resume a routine.';
/** Why Run now is off while the repair pause is set (spec UI 14). */
export const REPAIR_AND_RESUME_FIRST = 'Repair and resume this workflow first';

type NodeView = WorkflowAccountRepairView['nodes'][number];

export function isBrokenStep(node: NodeView): boolean {
  return node.state === 'needs_repair' || node.state === 'unassigned';
}

/** "Query" for the one query step a routine usually has; "Query step 2" when there are several. */
export function queryStepLabel(nodes: readonly NodeView[], nodeId: string): string {
  if (nodes.length <= 1) return 'Query';
  return `Query step ${String(nodes.findIndex((n) => n.nodeId === nodeId) + 1)}`;
}

/** The repair-pause facts the header, the trigger and the banner all read. */
export function workflowRepairState(view: WorkflowAccountRepairView | undefined): {
  repairPaused: boolean;
  broken: boolean;
} {
  if (!view?.repairEnabled) return { repairPaused: false, broken: false };
  return { repairPaused: view.repairPaused, broken: view.nodes.some(isBrokenStep) };
}
